const DownIcon = () => {
  return (
    <svg width="4" height="3" viewBox="0 0 4 3" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L2 2L3 1" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default DownIcon